export default __webpack_public_path__ + "static/media/faq.503e33e5.png";